import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const NavigateToLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    navigate(`/sector/67c59f894605e819d8fb86ca/details`);
  }, [dispatch, navigate]);

  return <></>;
};

export default NavigateToLogin;
